class AnimationTimer {
    constructor(animationFrameCallback) {
        this._animationFrameCallback = animationFrameCallback;
        this._requestAnimationFrameId = null;
    }
    start() {
        this.stop();
        this.update();
    }
    update() {
        this._animationFrameCallback();
        this._requestAnimationFrameId = window.requestAnimationFrame(() => { this.update(); });
    }
    stop() {
        if (this._requestAnimationFrameId !== null) {
            window.cancelAnimationFrame(this._requestAnimationFrameId);
            this._requestAnimationFrameId = null;
        }
    }
}
export { AnimationTimer };
